const getExternalLinkProps = (): { target: string; rel: string } => ({
    target: '_blank',
    rel: 'noreferrer noopener',
});

export default getExternalLinkProps;
